import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import apiClient from '../../canopy-ui-components/api';
import { RootState } from '../store';

export const fetchThemeConfig = createAsyncThunk(
    'appData/themeConfig',
    apiClient.getThemeConfig.bind(apiClient)
);

const themeSlice = createSlice({
    name: 'themeConfig',
    initialState: {
        preference: {
            isLoading: false,
            data: null,
            error: null,
        },
    },
    reducers: {},
    extraReducers: {
        [fetchThemeConfig.pending.type]: (state: any) => {
            state.preference.isLoading = true;
        },
        [fetchThemeConfig.fulfilled.type]: (
            state: any,
            action: PayloadAction<any>
        ) => {
            const payload =
                action.payload?.preference?.find(
                    ({ appId }: Record<string, any>) => appId === 'manager'
                ) || {};
            const supportedLocales = payload?.preference?.supportedLocales;
            if (supportedLocales) {
                payload.preference.supportedLocales = Object.keys(
                    supportedLocales
                ).map((l) => ({
                    value: l,
                    label: supportedLocales[l],
                }));
            }

            state.preference = {
                data: payload.preference,
                isLoading: false,
                error: null,
            };
        },
        [fetchThemeConfig.rejected.type]: (state: any, action: any) => {
            state.preference = {
                data: null,
                error: action?.error?.message || true,
                isLoading: false,
            };
        },
    },
});

export const selectTheme = (state: RootState): any => state.themeConfig;
export default themeSlice;
